var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameroon2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cameroon@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-408.000000, -376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "cameroon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barbados-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bahamas-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.13,0.42 C3.61746899,0.42 0.77,3.26746899 0.77,6.78 L0.77,41.05 C0.77,44.562531 3.61746899,47.41 7.13,47.41 L24.13,47.41 C24.13,31.7433333 24.13,16.0766667 24.13,0.41 L7.13,0.42 Z",
    id: "Shape",
    fill: "#52C162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.11,0.42 C24.11,16.0866667 24.11,31.7533333 24.11,47.42 L47.46,47.42 C47.46,31.7533333 47.46,16.0866667 47.46,0.42 L24.11,0.42 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,0.42 L47.45,0.42 C47.45,16.0866667 47.45,31.7533333 47.45,47.42 L64.4,47.42 C67.912531,47.42 70.76,44.572531 70.76,41.06 L70.76,6.78 C70.76,3.26746899 67.912531,0.42 64.4,0.42 Z",
    id: "Shape",
    fill: "#FFCE54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.38,30.21 C31.79,30.63 31.44,30.39 31.61,29.68 L32.25,27.02 C32.3977647,26.2267674 32.1387604,25.4122177 31.56,24.85 L29.62,23.17 C29.07,22.69 29.21,22.28 29.94,22.26 L32.65,22.18 C33.4252953,22.1084113 34.0885764,21.5933931 34.35,20.86 L35.2,17.95 C35.41,17.24 35.78,17.23 36.02,17.95 L37.02,20.82 C37.3074515,21.5557104 38.0009796,22.0533266 38.79,22.09 L41.56,22.09 C42.29,22.09 42.43,22.5 41.88,22.98 L39.77,24.83 C39.1981219,25.3911273 38.9594544,26.2094158 39.14,26.99 L39.81,29.33 C40.01,30.04 39.67,30.33 39.05,29.92 L36.8,28.53 C36.1063227,28.1459369 35.2579814,28.1728075 34.59,28.6 L32.38,30.21 Z",
    id: "Shape_2_copy_9-3",
    fill: "#F6BB42"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameroon2X);
export default __webpack_public_path__ + "static/media/cameroon@2x.5264727031ffdaf52cc35b5f3c47c89b.svg";
export { ForwardRef as ReactComponent };